import React, { FC } from 'react';

export const AmexLogo: FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 70 70"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.9,24.3l1.4-3.7h6.2v-6.7H14.1v42.4h42.4v-6.7h-5.9L48.4,47l-2.2,2.5H29.6V36.2h-5.5L31,20.7h6.7l1.6,3.5
          v-3.5h8.3L48.9,24.3L48.9,24.3z M44.3,26.8v-1.5l0.6,1.5l2.8,7.4h2.6l2.8-7.4l0.5-1.5v8.8h2.9V22.8h-4.8l-2.2,5.7l-0.6,1.6l-0.6-1.6
          l-2.2-5.7h-4.8V34h3V26.8L44.3,26.8z M38.1,34h3.3l-5-11.3h-3.9l-5,11.3h3.3l0.9-2.2h5.5L38.1,34L38.1,34z M33.9,26.6l0.6-1.4
          l0.6,1.4l1.2,2.9h-3.5L33.9,26.6L33.9,26.6z M31.9,36.2v11.3h9.4V45h-6.6v-2h6.4v-2.4h-6.4v-2h6.6v-2.4L31.9,36.2L31.9,36.2z
          M51.9,47.3h3.7l-5.3-5.6l5.3-5.6h-3.7l-3.4,3.7l-3.4-3.7h-3.8l5.3,5.7l-5.3,5.6h3.6l3.4-3.7L51.9,47.3L51.9,47.3z M53.3,41.8
          l3.2,3.3v-6.5L53.3,41.8L53.3,41.8z"
        fill="#006FCF"
      />
    </svg>
  );
};
